<form class="flex-100" [formGroup]="filtersForm" style="width:420px;">
    <div class="flex-row my-1"  style="border-bottom:1px solid rgba(189, 177, 213, 1)">
      <span class="flex-90 subtitle-4 mxs-1" style="line-height: inherit;">
        Filtros Prestadores
      </span>
      <mat-icon class="flex-1-1-auto" color="primary" style="line-height: 0.8"
        (click)="setProvidersFiltersVisible()">
        {{ providersFiltersVisible ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
      </mat-icon>
    </div>

    @if(loadingProvidersFilters) {
      <mat-progress-bar mode="indeterminate" [value]="100"></mat-progress-bar>
    }

    <div class="flex-column" [@detailExpand]="providersFiltersVisible ? 'expanded' : 'collapsed'">
      <app-checkbox-input
        [form]="filtersForm"
        label="Incluir domicilio de prestadores"
        name="includeProvidersAddress"
        [disabled]="!enableFilters">
      </app-checkbox-input>

      <app-checkbox-input
        [form]="filtersForm"
        label="Incluir zonas de trabajo de prestadores"
        name="includeProvidersZone"
        [disabled]="!enableFilters">
      </app-checkbox-input>

      <div class="flex-row pls-2 pts-2 pbs-2" style="gap:0.75em">
        <app-switcheable-chip
          [form]="filtersForm"
          name="includeActiveProviders"
          [disabled]="!enableFilters || disableActions  || !includProvidersAddressChecked && !includeProvidersZoneChecked"
          text="Activo"
          [active]='true'
          [loading]="loadingActive$ | async"
          (change)="statusFilterEmitter.emit({value: $event, name:'btn_active' }); timmer()">
        </app-switcheable-chip>

        <app-switcheable-chip
          [form]="filtersForm"
          name="includeInactiveProviders"
          [disabled]="!enableFilters || disableActions  || !includProvidersAddressChecked && !includeProvidersZoneChecked"
          text="Inactivo"
          [active]="false"
          [loading]="loadingInactive$ | async"
          (change)="statusFilterEmitter.emit({value: $event, name:'btn_inactive' }); timmer()">
        </app-switcheable-chip>

        <app-switcheable-chip
          [form]="filtersForm"
          name="includeInactiveCancelledProviders"
          [disabled]="!enableFilters || disableActions  || !includProvidersAddressChecked && !includeProvidersZoneChecked"
          text="Cancelado"
          [active]='true'
          [loading]="loadingInactiveCancelled$  | async"
          (change)="statusFilterEmitter.emit({ value: $event, name:'btn_cancelled' }); timmer()">
        </app-switcheable-chip>

        <app-switcheable-chip
          [form]="filtersForm"
          name="includeInactivePossibleProviders"
          [disabled]="!enableFilters || disableActions  || !includProvidersAddressChecked && !includeProvidersZoneChecked"
          text="Posible"
          [active]='true'
          [loading]="loadingInactivePossible$ | async"
          (change)="statusFilterEmitter.emit({ value: $event, name:'btn_possible' }); timmer()">
        </app-switcheable-chip>
      </div>
    </div>

    <div class="flex-row my-3"  style="border-bottom:1px solid rgba(189, 177, 213, 1)">
      <span class="flex-90 subtitle-4 mxs-1" style="line-height: inherit;">
        Filtros Pacientes
      </span>
      <mat-icon class="flex-1-1-auto" color="primary" style="line-height: 0.8"
        (click)="setPatientsFiltersVisible()">
        {{ patientsFiltersVisible ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
      </mat-icon>
    </div>

    @if(loadingPatientsFilters) {
      <mat-progress-bar mode="indeterminate" [value]="100"></mat-progress-bar>
    }

    <div class="flex-column" [@detailExpand]="patientsFiltersVisible ? 'expanded' : 'collapsed'">
        <div class="flex-column gap-1em">
            <app-checkbox-input [form]="filtersForm" [label]="'Incluir pacientes con la misma especialidad'"
                [name]="this.INCLUDE_PATIENTS" [disabled]="!this.enableFilters">
            </app-checkbox-input>
            <div class="pbs-2 pxs-2">
                <span class="flex mbs-1 subtitle-4">Con acuerdos creados:</span>
                <app-select-input [elements]="fromDateList" [name]="this.FROMDATE" [form]="this.filtersForm"
                    [placeholder]="this.fromDateListSelected.description" [calculateId]="calculateIdFromDate"
                    [calculateName]="calculateNameFromDate" [defaultValue]="fromDateListSelected"
                    (selected)="onFilterFromDate($event)" [disabled]="!showPatientsFilters">
                </app-select-input>
            </div>
            <div class="flex-row gap-1em p-3">
                <app-switcheable-chip [form]="filtersForm" [name]="INCLUDE_ACTIVE_PATIENTS"
                    [disabled]="!showPatientsFilters || disableActions" text="Activo" [active]="true"
                    [loading]="isLoadingActiveAddress || isLoadingActiveZone"
                    (change)="onFilterPatientsByStatus(patientStatus.ACTIVE,!activePatientsSelected);timmer()">
                </app-switcheable-chip>

            <app-switcheable-chip [form]="filtersForm" [name]="INCLUDE_INACTIVE_PATIENTS"
                [disabled]="!showPatientsFilters || disableActions" text="Inactivo" [active]="true"
                [loading]="isLoadingInactiveAddress || isLoadingInactiveZone"
                (change)="onFilterPatientsByStatus(patientStatus.INACTIVE,!inactivePatientsSelected);timmer()">
            </app-switcheable-chip>

    </div>
        </div>
    </div>
  </form>
